<template>
  <div>
    <h2 class="text-center" label="email" label-for="email">Test Email</h2>
    <b-form-group label="email" label-for="email">
      <b-form-input id="email" type="email" v-model="email"></b-form-input>
    </b-form-group>

    <b-form-group label="statement_type" label-for="statement_type">
      <b-form-select
        id="statement_type"
        :options="options"
        v-model="statement_type"
      ></b-form-select>
    </b-form-group>

    <b-form-group label="order_id" label-for="order_id">
      <b-form-input id="order_id" type="text" v-model="order_id"></b-form-input>
    </b-form-group>

    <b-button class="mx-4" variant="primary" @click="sendMail"
      >send Customer Mail</b-button
    >
    <b-button class="mx-4" variant="primary" @click="getStatement"
      >statement</b-button
    >
  </div>
</template>
<script>
import axios from "axios";
import order_api from "@/api/order";
import user_api from "@/api/user";
const AWS = require("aws-sdk");

export default {
  name: "test",
  components: {},
  data: () => {
    return {
      email: null,
      order_id: 8378,
      statement_type: null,
      loading: false,
    };
  },
  computed: {
    s_order_id() {
      return parseInt(this.order_id) || 0;
    },
    options() {
      return [
        "invoice-statement",
        "fulfilment-note-one",
        "fulfilment-note-two",
      ];
    },
  },

  mounted() {
    this.$store.dispatch("orders/myorders");
  },

  methods: {
    setLocation() {
      const lat = 18.109581;
      const long = -77.297508;
      user_api
        .updateLocation({ lat, long })
        .then((r) => console.log("results:", r));
    },

    sendMail() {
      const { s_order_id, email, statement_type } = this;
      const path = `order/${s_order_id}/client-email`;
      const first_name = "Courtney",
        last_name = "Walker";

      const params = {
        email,
        first_name,
        last_name,
        statement_type,
      };

      axios
        .post(path, params)
        .then((r) => {
          console.log("results:", r);
        })
        .catch((err) => console.error(err));
    },

    getStatement() {
      const { s_order_id, email, statement_type } = this;
      const path = `order/${s_order_id}/get-statement-url`;

      const params = {
        email,
        statement_type,
      };

      axios.get(path, { params }).then((r) => {
        console.log("results:", r);
      });
    },

    async getPresigned() {
      const {
        data: {
          success: { data },
        },
      } = await order_api.fetchPresigned("presigned", "lovely.jpg");
      console.log("data", data);
      const { key, keyUrl, presignedUrl } = JSON.parse(data);
      console.log("credentials", { key, keyUrl, presignedUrl });
    },

    async getToken() {
      const {
        data: {
          success: { data },
        },
      } = await order_api.fetchPresigned("token");
      console.log("data", data);
      const { key, secret, token } = JSON.parse(data);
      console.log("credentials", { key, secret, token });
      const region = "us-east-1";
      const options = {
        //keyPrefix: "uploads/",
        region,
        accessKeyId: key,
        secretAccessKey: secret,
        sessionToken: token,
      };
      AWS.config.update(options);

      const client = new AWS.DynamoDB.DocumentClient();
      var params = {
        TableName: "oms_location_tracking",
        Item: {
          deviceId: "sjkdasdjasjd",
          timestamp: Date.now(),
          latitude: 78.45,
          longitude: -75.78,
        },
      };
      await client.put(params).promise();
    },
  },
};
</script>
<style></style>
